export class AysUser {

    constructor(
        public oid?: string,
        public displayName?: string
    ) {
    }

    public static fromObject(obj: any) {
        return new AysUser(
            obj.oid,
            obj.displayName
        );
    }
}
